import { supabaseClient } from './client'
import { useAuthStore } from '~/client/common/stores/auth'

/**
 * Get the current authenticated user's ID and active entity ID
 * @returns User info with id and active_entity_id, or null if not authenticated
 */
export async function getMe(): Promise<{
  id: number
  active_entity_id: number | null
  email: string | null
} | null> {
  const userDetail = useAuthStore.getState().userDetail

  if (userDetail?.id && userDetail?.active_entity?.id) {
    return {
      id: userDetail.id,
      active_entity_id: userDetail.active_entity.id,
      email: userDetail.email,
    }
  }

  if (!userDetail) return null

  const { data, error } = await supabaseClient.from('identity_user').select('id, active_entity_id, email').eq('id', userDetail.id).maybeSingle()

  if (error || !data) return null

  return {
    id: data.id,
    active_entity_id: data.active_entity_id,
    email: data.email,
  }
}

/**
 * Get the current ISO timestamp
 * @returns ISO string of current date/time
 */
export function nowIso(): string {
  return new Date().toISOString()
}
